import {
    call,
    put,
    takeLeading,
} from 'redux-saga/effects';
import { apiRequest } from '../../api';
import { APPLICATION_JSON, CONTENT_TYPE } from '../../api/headers';
import {
    DEFAULT_BASE_URL,
    GET_PAGEFOOTER_INFO_URL,
} from '../../api/urls';
import { GET_PAGEFOOTER_INFO } from '../../actions/actionTypes';
import { setPageFooterInfoAction } from '../../actions/actionCreators';

export function* getPageFooterInfo() {
    const requestConfig = {
        headers: {
            [CONTENT_TYPE]: APPLICATION_JSON,
        },
        baseURL: DEFAULT_BASE_URL,
        url: GET_PAGEFOOTER_INFO_URL,
    };
    try {
        const { data } = yield call(apiRequest, requestConfig);
        yield put(setPageFooterInfoAction(data));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
    }
}

export default function* watchPageFooterInfo() {
    yield takeLeading(GET_PAGEFOOTER_INFO, getPageFooterInfo);
}
